import type { MelwaysZone } from '@seek/melways-sites';

import type { Market } from '../types';

export const getMelwaysZoneByMarket = (market: Market): MelwaysZone => {
  switch (market) {
    case 'NZ':
      return 'anz-2';
    case 'HK':
      return 'asia-1';
    case 'TH':
      return 'asia-3';
    case 'ID':
      return 'asia-4';
    case 'MY':
      return 'asia-5';
    case 'PH':
      return 'asia-6';
    case 'SG':
      return 'asia-7';
    default:
      return 'anz-1';
  }
};
